'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _immutableHelper = require('../../../common/utils/immutableHelper');

var _connectionsSelector = require('./reducers/connectionsSelector');

var _elementConstants = require('../../../common/elements/elementConstants');

// Selector


// Selectors
var getConnectingElements = function getConnectingElements(connectionsState, _ref) {
    var id = _ref.id;
    return (0, _immutableHelper.toIdArray)((0, _connectionsSelector.getConnections)(connectionsState).filter(function (connectedElements) {
        return connectedElements.includes(id);
    }));
};

// Selector


// Constants
// Utils
var getIsConnected = function getIsConnected(connectionsState, _ref2) {
    var id = _ref2.id;

    var connectionData = (0, _connectionsSelector.getConnections)(connectionsState).get(id);
    return connectionData && connectionData.size;
};

var handleSingleElementMove = function handleSingleElementMove(elementConnectionsManager, store, action, move) {
    // Find the ID of the thing being moved
    var id = move.id;

    // Determine if the moved element is a 'connecting' element and allow it to perform
    // some updates to its state

    var isConnected = getIsConnected(elementConnectionsManager.store.getState(), { id: id });
    if (isConnected) {
        var sourceSpec = elementConnectionsManager.registry.getSource(id);
        sourceSpec.handleConnectionSourceMove(action, move);
    }

    // Figure out if it has any connected elements
    var connectedElementIdArray = getConnectingElements(elementConnectionsManager.store.getState(), { id: id });

    // For each connected element, invoke the appropriate method
    connectedElementIdArray.forEach(function (connectedElementId) {
        // Get the connected element from the registry
        var sourceSpec = elementConnectionsManager.registry.getSource(connectedElementId);

        // Invoke the appropriate spec method
        sourceSpec.handleConnectedElementMove(action, move);
    });

    return null;
};

var handleElementMultiMoveAction = function handleElementMultiMoveAction(elementConnectionsManager, store, action) {
    return action.moves.map(function (move) {
        return handleSingleElementMove(elementConnectionsManager, store, action, move);
    });
};

/**
 * Allows standard Milanote store actions to be intercepted by the elementConnections Manager.
 */

exports.default = function (elementConnectionsManager) {
    return function (store) {
        return function (next) {
            return function (action) {
                // Prevent handling the undo & redo actions
                if (action.isUndo || action.isRedo) return next(action);

                switch (action.type) {
                    case _elementConstants.ELEMENT_MOVE_MULTI:
                        handleElementMultiMoveAction(elementConnectionsManager, store, action);
                        break;
                    default:
                        break;
                }

                return next(action);
            };
        };
    };
};


//////////////////
// WEBPACK FOOTER
// ./src/client/components/connections/createElementConnectionsMiddleware.js
// module id = 1710
// module chunks = 0